var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'safety-assistant-app': _vm.safetyAssistant }},[_c('v-main',[_c('router-view')],1),_c('NotificationSnack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }